import { getDataNodeIdFromTreeId } from './utils/treeId';

const prefix = 'decomposition-tree';

export type DecompositionTreeTestIdScope = 'move';

const scopedBase = (scope?: DecompositionTreeTestIdScope) => (scope ? `${prefix}-${scope}` : prefix);

export const DECOMPOSITION_TREE_TEST_ID = {
  page: `${prefix}-page`,
  tree: (scope?: DecompositionTreeTestIdScope) => scopedBase(scope),
  collapseAllButton: `${prefix}-collapse-all-button`,
  addNodeButton: `${prefix}-add-node-button`,
  infiniteScrollSentinel: 'infinite-scroll-sentinel',

  item: (dataNodeId: string, scope?: DecompositionTreeTestIdScope) => `${scopedBase(scope)}-item-${dataNodeId}`,
  nodeLink: (dataNodeId: string, scope?: DecompositionTreeTestIdScope) =>
    `${scopedBase(scope)}-node-link-${dataNodeId}`,
  expandButton: (dataNodeId: string, scope?: DecompositionTreeTestIdScope) =>
    `${scopedBase(scope)}-expand-button-${dataNodeId}`,

  showMoreItem: (parentTreeId: string, scope?: DecompositionTreeTestIdScope) =>
    `${scopedBase(scope)}-show-more-item-${getDataNodeIdFromTreeId(parentTreeId)}`,
  showMoreButton: (parentTreeId: string, scope?: DecompositionTreeTestIdScope) =>
    `${scopedBase(scope)}-show-more-button-${getDataNodeIdFromTreeId(parentTreeId)}`,

  errorItem: (parentTreeId: string, scope?: DecompositionTreeTestIdScope) =>
    `${scopedBase(scope)}-error-item-${getDataNodeIdFromTreeId(parentTreeId)}`,

  nodeActionsButton: (dataNodeId: string) => `${prefix}-node-actions-button-${dataNodeId}`,
  nodeActionsMenu: (dataNodeId: string) => `${prefix}-node-actions-menu-${dataNodeId}`,
  nodeActionOpenDetails: `${prefix}-node-action-open-details`,
  nodeActionAddChild: `${prefix}-node-action-add-child`,
  nodeActionMove: `${prefix}-node-action-move`,

  moveDialog: `${prefix}-move-dialog`,
  moveToRootButton: `${prefix}-move-to-root-button`,
  moveLoadMoreButton: `${prefix}-move-load-more-button`,
  moveCancelButton: `${prefix}-move-cancel-button`,
  moveSaveButton: `${prefix}-move-save-button`
} as const;
